"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _miniProgramVersionApi = require("@/api/miniProgramVersionApi");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var UPLOAD_STATUS = {
  CREATED: {
    label: '已创建',
    type: ''
  },
  WAITING_RUNNER: {
    label: '等待Runner',
    type: 'warning'
  },
  CLONING: {
    label: '拉取代码中',
    type: 'warning'
  },
  CHECKING: {
    label: '校验中',
    type: 'warning'
  },
  WAITING_BUILD: {
    label: '等待编译',
    type: 'warning'
  },
  BUILDING: {
    label: '编译中',
    type: 'warning'
  },
  UPLOADING: {
    label: '上传中',
    type: 'warning'
  },
  SUCCESS: {
    label: '上传成功',
    type: 'success'
  },
  FAILED: {
    label: '上传失败',
    type: 'danger'
  },
  CANCELED: {
    label: '已取消',
    type: 'info'
  }
};
var BATCH_STATUS = {
  RUNNING: {
    label: '进行中',
    type: 'warning'
  },
  SUCCESS: {
    label: '全部成功',
    type: 'success'
  },
  PARTIAL_SUCCESS: {
    label: '部分成功',
    type: 'warning'
  },
  FAILED: {
    label: '全部失败',
    type: 'danger'
  }
};
var _default = exports.default = {
  name: 'BatchUploadProgress',
  data: function data() {
    return {
      visible: false,
      loading: false,
      batchId: null,
      batch: null,
      timer: null,
      logVisible: false,
      versionDetail: null,
      cancelingId: null
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    open: function () {
      var _open = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(batchId) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.stopPolling();
              this.batchId = batchId;
              this.batch = null;
              this.visible = true;
              _context.n = 1;
              return this.loadDetail();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function open(_x) {
        return _open.apply(this, arguments);
      }
      return open;
    }(),
    loadDetail: function () {
      var _loadDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(!this.batchId || !this.visible)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              this.loading = !this.batch;
              _context2.p = 2;
              _context2.n = 3;
              return (0, _miniProgramVersionApi.getBatchUploadDetail)(this.batchId);
            case 3:
              this.batch = _context2.v;
            case 4:
              _context2.p = 4;
              this.loading = false;
              return _context2.f(4);
            case 5:
              if (this.batch && this.batch.batchStatus === 'RUNNING' && this.visible) {
                this.timer = setTimeout(function () {
                  return _this.loadDetail();
                }, 3000);
              } else {
                this.$emit('finished');
              }
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[2,, 4, 5]]);
      }));
      function loadDetail() {
        return _loadDetail.apply(this, arguments);
      }
      return loadDetail;
    }(),
    stopPolling: function stopPolling() {
      if (this.timer) clearTimeout(this.timer);
      this.timer = null;
    },
    showLog: function () {
      var _showLog = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(versionId) {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.versionDetail = null;
              this.logVisible = true;
              _context3.n = 1;
              return (0, _miniProgramVersionApi.getVersionDetail)(versionId);
            case 1:
              this.versionDetail = _context3.v;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function showLog(_x2) {
        return _showLog.apply(this, arguments);
      }
      return showLog;
    }(),
    cancelUpload: function cancelUpload(row) {
      var _this2 = this;
      this.$confirm("\u786E\u5B9A\u4E2D\u6B62 ".concat(row.appName || row.appId, " \u7684\u4E0A\u4F20\u4EFB\u52A1\uFF1F"), '中止上传', {
        type: 'warning',
        confirmButtonText: '确认中止'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _this2.cancelingId = row.id;
              _context4.p = 1;
              _context4.n = 2;
              return (0, _miniProgramVersionApi.cancelVersionUpload)(row.id);
            case 2:
              _this2.$message.success('已发出中止指令');
              _this2.stopPolling();
              _context4.n = 3;
              return _this2.loadDetail();
            case 3:
              _context4.p = 3;
              _this2.cancelingId = null;
              return _context4.f(3);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, null, [[1,, 3, 4]]);
      }))).catch(function () {});
    },
    canCancelUpload: function canCancelUpload(status) {
      return ['WAITING_RUNNER', 'CLONING', 'CHECKING', 'WAITING_BUILD', 'BUILDING', 'UPLOADING'].includes(status);
    },
    getUploadStatus: function getUploadStatus(status) {
      return UPLOAD_STATUS[status] || {
        label: status || '-',
        type: 'info'
      };
    },
    getBatchStatus: function getBatchStatus(status) {
      return BATCH_STATUS[status] || {
        label: status || '-',
        type: 'info'
      };
    },
    getUploadStep: function getUploadStep(row) {
      var steps = {
        CREATED: 1,
        WAITING_RUNNER: 1,
        CLONING: 2,
        CHECKING: 3,
        WAITING_BUILD: 4,
        BUILDING: 4,
        UPLOADING: 5,
        SUCCESS: 5
      };
      return steps[row.currentStep || row.uploadStatus] || 1;
    }
  }
};